<template>
  <div class="container-fluid">
    <div class="contents setting change">
      <tab />

      <b-form @submit="onSubmit">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-3"
            role="tabpanel"
            aria-labelledby="pills-3-tab"
          >

            <div class="row g-0 table-type header-col">

              <div class="col-sm-4">
                  <span class="required">{{ $t("title.setting.currentemail") }}</span>
              </div>
              <div class="col-sm-8">
                  <input
                  type="text"
                  name="curemail"
                  v-model="form.curemail"
                  required
                  />
              </div>

              <div class="col-sm-4">
                  <span class="required">{{ $t("title.setting.newemail") }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="newemail"
                  v-model="form.newemail_re"
                  required
                />
              </div>

              <div class="col-sm-4">
                  <span class="required">{{ $t("title.setting.newemailconfirm") }}</span>
              </div>
              <div class="col-sm-8">
                <input
                    type="text"
                    name="newemail_re"
                    v-model="form.newemail_re"
                    required
                />
              </div>

            </div>

            <div class="btn-bottom-wrapper">
              <b-button
                size="xl"
                variant="primary"
                :aria-label="$t('button.common.save')"
                type="submit"
                >{{ $t("button.common.save") }}</b-button>
            </div>

          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";

export default {
  name: "EmailChange",
  components: {
    tab,
  },
  data() {
    return {
      form: {
        curemail: "",
        newemail: "",
        newemail_re: "",
      },
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (this.form.curemail === "") {
        alert(this.$i18n.t('alert.setting.enter_current_email'));
        return false;
      }

      if (this.form.newemail === "") {
        alert(this.$i18n.t('alert.setting.enter_new_email'));
        return false;
      }

      if (this.form.newemail !== this.form.newemail_re) {
        alert(this.$i18n.t('alert.setting.new_email_do_not_match'));
        return false;
      }

      this.set_ownerchangeemail();
      // if (
      //   confirm(
      //     "이메일 확인 절차를 완료하려면 새 이메일 주소를\n확인하세요. 계속하시겠습니까?"
      //   )
      // ) {
      //   this.set_ownerchangeemail();
      // }
    },
    set_ownerchangeemail() {
      ax.set_ownerchangeemail(this.form, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.form.curemail = "";
          this.form.newemail = "";
          this.form.newemail_re = "";
        } else {
          /*this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: data
          })*/

          return false;
        }
      });
    },
  },
};
</script>